import { Capacitor } from '@capacitor/core'
import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics'

export type HapticPattern =
  | { kind: 'impact'; style: ImpactStyle }
  | { kind: 'notification'; type: NotificationType }
  | { kind: 'selection' }

let lastHapticAt = 0
let lastSelectionAt = 0

export function triggerHaptic(pattern?: HapticPattern): void {
  if (!pattern) return
  const now = Date.now()
  if (pattern.kind === 'selection') {
    if (now - lastSelectionAt < 360) return
    lastSelectionAt = now
  } else {
    if (now - lastHapticAt < 240) return
    lastHapticAt = now
  }
  if (!Capacitor.isNativePlatform()) {
    if (typeof navigator !== 'undefined' && 'vibrate' in navigator) {
      const vibrate = navigator.vibrate.bind(navigator)
      if (pattern.kind === 'selection') {
        vibrate(8)
        return
      }
      if (pattern.kind === 'impact') {
        const duration =
          pattern.style === ImpactStyle.Heavy ? 28 : pattern.style === ImpactStyle.Medium ? 18 : 10
        vibrate(duration)
        return
      }
      if (pattern.type === NotificationType.Success) {
        vibrate([12, 40, 12])
        return
      }
      if (pattern.type === NotificationType.Warning) {
        vibrate([24, 40, 24])
        return
      }
      vibrate([32, 40, 32])
    }
    return
  }

  if (pattern.kind === 'impact') {
    void Haptics.impact({ style: pattern.style })
    return
  }

  if (pattern.kind === 'selection') {
    void Haptics.selectionChanged()
    return
  }

  void Haptics.notification({ type: pattern.type })
}
